var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M4.09 10.1699C4.2 10.5649 4.405 10.9199 4.675 11.2099L0.955 14.1549C0.845 14.2449 0.714999 14.2849 0.594999 14.2849C0.289999 14.2849 0 14.0449 0 13.6949C0 13.5149 0.0800004 13.3449 0.225 13.2299L4.09 10.1699Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M8.935 10.0698L13.59 13.5798C13.3 13.8648 13.1 14.2398 13.03 14.6598L8.375 11.1498C8.645 10.8448 8.84 10.4748 8.935 10.0698Z",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M19.9994 11.7701V11.8001C19.9994 11.9851 19.9144 12.1551 19.7644 12.2701L16.9144 14.4151C16.7894 14.0201 16.5544 13.6751 16.2344 13.4251L19.0544 11.3001C19.4444 11.0101 19.9994 11.2851 19.9994 11.7701Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M9 9.5C9 9.695 8.975 9.885 8.935 10.07C8.84 10.475 8.645 10.845 8.375 11.15C7.92 11.67 7.25 12 6.5 12C5.75 12 5.135 11.695 4.675 11.21C4.405 10.92 4.2 10.565 4.09 10.17C4.03 9.955 4 9.73 4 9.5C4 8.12 5.12 7 6.5 7C7.88 7 9 8.12 9 9.5Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17 15C17 16.105 16.105 17 15 17C13.895 17 13 16.105 13 15C13 14.885 13.01 14.77 13.03 14.66C13.1 14.24 13.3 13.865 13.59 13.58C13.955 13.225 14.45 13 15 13C15.46 13 15.89 13.16 16.23 13.425C16.55 13.675 16.785 14.02 16.91 14.415C16.965 14.6 16.995 14.795 16.995 15H17Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineNone);
export default __webpack_public_path__ + "static/media/line-none.9d347c4a786c7746b87bc9ce3e7beaef.svg";
export { ForwardRef as ReactComponent };